import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionEn = () => {
  return (
    <section className="app-section">
      <h1>Cách cài đặt Tango: Hướng dẫn từng bước</h1>
      <h5>Phát trực tiếp. Kết nối. Thưởng thức – Mọi lúc, Mọi nơi!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>Được viết bởi Tango</span>
          <span>Đã cập nhật ngày hôm qua</span>
        </div>
      </div>
      <p>
        <b>
          Tango có sẵn trên nhiều nền tảng, giúp bạn dễ dàng phát trực tiếp và tận hưởng giải trí trực tiếp mọi lúc, mọi nơi.
        </b>
      </p>
      <hr/>
      <h2>🤖 Dành cho người dùng Android</h2>
      <p>
        Bạn có thể tải ứng dụng Tango trực tiếp từ:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <h2>Dành cho iOS:</h2>
      <p>
        <b>Nếu bạn đã từng cài đặt Tango trên thiết bị iOS của mình, bạn có thể tải lại từ App Store.</b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <b>1. Mở App Store:</b> Truy cập App Store trên thiết bị iOS của bạn.
      </p>
      <p>
        <b>2. Nhấn vào ảnh hồ sơ của bạn:</b> Ở góc trên bên phải màn hình để mở cài đặt tài khoản.
      </p>
      <p>
        <b>3. Chuyển đến "Ứng dụng" hoặc "Lịch sử mua hàng":</b> uyệt danh sách ứng dụng bạn đã tải trước đó hoặc sử dụng thanh tìm kiếm ở trên để nhập "Tango".
      </p>
      <p>
        <b>4. Tải lại ứng dụng Tango:</b> Khi tìm thấy Tango trong danh sách, nhấn vào biểu tượng đám mây với mũi tên để tải lại ứng dụng.
      </p>
      <p>
        <b>5. Mở ứng dụng Tango sau khi cài đặt:</b> Và làm theo hướng dẫn đăng ký hoặc đăng nhập.
      </p>
      <hr />
      <h2>Mới sử dụng Tango? Dễ dàng thêm Tango vào màn hình chính để truy cập nhanh</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <b>1. Mở trang web của Tango:</b> Truy cập liên kết <a href="https://tango.me">https://tango.me</a> trên trình duyệt di động của bạn.
      </p>
      <p>
        <b>2. Nhấn vào biểu tượng Chia sẻ:</b> Là hình vuông có mũi tên hướng lên ở dưới cùng màn hình.
      </p>
      <p>
        <b>3. Chọn "Thêm vào màn hình chính":</b> Từ menu và phím tắt của Tango sẽ được thêm vào màn hình chính của thiết bị bạn.
      </p>

      <p>Sau khi cài đặt, bạn đã sẵn sàng phát trực tiếp, ủng hộ những nhà sáng tạo yêu thích và tận hưởng giải trí không giới hạn – tất cả ngay trong tầm tay!</p>
      <b>Hãy bắt đầu ngay và tham gia vào hành động! 🎉</b>
    </section>
  );
};

export default SectionEn;
